<template>
    <div class="view dashboard">
        <section class="landing">
            <div id="edit">
                <edit />
            </div>
        </section>
    </div>
</template>

<script>
const Edit = () => import("../components/pages/Edit");
export default {
    name: 'EditView',
    components: { Edit },
}
</script>
